export default function DynamicNativeController(
  $state,
  CreativeService,
  RenderService,
  RtbPixelService,
  SettingsService
) {
  const vm = this;
  vm.renderService = RenderService;
  vm.creativeService = CreativeService;
  vm.creative = CreativeService.creative;

  function initialize() {
    SettingsService.subnavHeading = 'Dynamic Native';
    if (!$state.params.maintainState) {
      CreativeService.resetCreative();
      CreativeService.setDefaultCreative();
      RtbPixelService.reset();
    }

    if (!RenderService.site.isExternalDemo) {
      SettingsService.showBuilderHeader = true;
    }

    RenderService.setSite();
  }

  initialize();

  return vm;
}

DynamicNativeController.$inject = [
  '$state',
  'CreativeService',
  'RenderService',
  'RtbPixelService',
  'SettingsService'
];
